import { Funnel, useFunnelStore } from '@hooks/use-funnel';

export const ApplicationHeader = () => {
  // 렌더링 최적화를 위해 다음과 같이 useFunnelStore를 직접 사용
  const currentScreen = useFunnelStore((state) => state.currentScreen);
  const funnelHeaderText = currentScreen === 'Purchase' ? '결제' : '예약';

  return <Funnel.Header text={funnelHeaderText} />;
};
